module.exports = __webpack_public_path__ + "img/首页2-7-hover.c7747f82.svg";